import React, { createContext, useState, useContext, useEffect } from 'react';
import { AuthServices, api } from '../services';
const AuthContext = createContext({});

export function useAuth() {
  const context = useContext(AuthContext);

  return context;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuth, setIsAuth] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const storagedUser = localStorage.getItem('user');
    const storagedToken = localStorage.getItem('token');

    if(storagedToken && storagedUser) {
      setSessionExpired(false);
      api.defaults.headers['x-access-token'] = storagedToken;
      setUser(JSON.parse(storagedUser));
      setIsAuth(true);
    }
  }, []);

  async function signin(payload) {
    try {
      const response = await AuthServices.signin(payload);
      setSessionExpired(false);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('token', response.data.token);
      api.defaults.headers['x-access-token'] = response.data.token;
      setUser(response.data.user);
      setIsAuth(response.data.auth);
    } catch(error) {
      return({ error: true });
      // return error.response.data;
    }
  }

  function logout(sessionExpired = false) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    setIsAuth(false);
    if(sessionExpired) {
      setSessionExpired(true);
    }
  }
  return (
    <AuthContext.Provider value={{ auth: isAuth, sessionExpired, user, signin, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;